
import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';
import AreaHero from '../components/AreaHero';
import AreaServices from '../components/AreaServices';
import AreaTestimonials from '../components/AreaTestimonials';
import AreaCTA from '../components/AreaCTA';
import { useSEO, generateAreaPageSchema, generateBreadcrumbSchema } from '../../../utils/seo';

export default function NorthwoodPage() {
  const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

  useSEO({
    title: 'Painters & Decorators Northwood Greater London | Brushour',
    description: 'Premium painting and decorating services in Northwood, Greater London. Covering Northwood Town, Northwood Hills, and Eastbury. Fully insured, 18+ years experience. Free quotes available.',
    keywords: 'painters Northwood, decorators Northwood London, painting services Northwood Hills, Northwood painters decorators, decorating Eastbury',
    canonical: `${SITE_URL}/areas/northwood`,
    schema: [
      generateAreaPageSchema('Northwood', 'Greater London', 'northwood', 51.6282, -0.4237, 'HA6'),
      generateBreadcrumbSchema([
        { name: 'Home', url: SITE_URL },
        { name: 'Areas', url: `${SITE_URL}/areas` },
        { name: 'Northwood', url: `${SITE_URL}/areas/northwood` },
      ]),
    ],
  });

  const areaData = {
    name: 'Northwood',
    region: 'Greater London',
    description: 'Premium painting and decorating services in Northwood. We specialize in transforming homes and businesses with our comprehensive range of painting services, delivering outstanding quality and customer satisfaction across Northwood.',
    heroImage: 'https://public.readdy.ai/ai/img_res/096e209702592a7e6e2055b681282bcf.jpg',
    serviceAreas: ['Northwood Town', 'Northwood Hills', 'Eastbury', 'Moor Park'],
  };

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <AreaHero data={areaData} />
      <AreaServices area="Northwood" />
      <AreaTestimonials area="Northwood" />
      <AreaCTA area="Northwood" />
      <Footer />
    </div>
  );
}
